//Header Banner Slides 
var currentHeaderSlide = 0;
window.addEventListener('load', function(){
    window.setInterval(function(){
        currentHeaderSlide++;
        if(currentHeaderSlide==3)
            currentHeaderSlide = 0;
        document.querySelectorAll('.headerbanner__item').forEach(function(elm, indx){
            if(indx==currentHeaderSlide){
                elm.classList.add('show');
            }else{
                elm.classList.remove('show');
            }
        });
    }, 2000);
});

//update certificate display on plot products
function plotWidgetChanged(){
    var firsTitle = (document.querySelector('.plotwidget select[name="properties[First Title]"]') ? document.querySelector('.plotwidget select[name="properties[First Title]"]') : document.querySelector('.plotwidget select[name="properties[Title]"]'));
    var secondTitle = (document.querySelector('.plotwidget select[name="properties[Second Title]"]') ? document.querySelector('.plotwidget select[name="properties[Second Title]"]') : false);

    var firstName = (document.querySelector('.plotwidget input[name="properties[First Name]"]') ? document.querySelector('.plotwidget input[name="properties[First Name]"]') : document.querySelector('.plotwidget input[name="properties[Name]"]'));
    var secondName = (document.querySelector('.plotwidget input[name="properties[Second Name]"]') ? document.querySelector('.plotwidget input[name="properties[Second Name]"]') : false);

    var certDate = document.querySelector('.plotwidget input[name="properties[Certificate Date]"]');

    if(firsTitle){
        document.querySelector('.certcontainer__text_first').innerHTML = firsTitle.value + ' ' + firstName.value;
    }

    if(secondTitle){
        document.querySelector('.certcontainer__text_second').innerHTML = secondTitle.value + ' ' + secondName.value;
    }

    if(certDate){
        if(certDate.value!=''){
            let userDte = certDate.value;
            // set the time to midnight on the user date to avoid any timezone issues
            if(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(userDte)){ //yyyy-mm-dd
                if(!/Version\/15.*Safari/.test(navigator.userAgent)){
                    //only if not Safari 15
                    userDte = userDte + ' 00:00:01';
                }
            }
            const tmpDte = new Date(userDte);
            document.querySelector('.certcontainer__text_cert').innerHTML = tmpDte.toDateString();
        }else{
            document.querySelector('.certcontainer__text_cert').innerHTML = 'Certificate Date Test';
        }
    }
}

//submit upsell item
function upsellAdd(val){
    var frm = document.getElementById('product_form_' + val);
    var upsellItem = frm.parentNode;

    var xhr = new XMLHttpRequest();
    var formData = new FormData(frm);
    xhr.open('POST', frm.getAttribute('action'));

    upsellItem.classList.add('done');

    xhr.responseType = 'document';
    xhr.onload = function() {
        if (xhr.status === 200) {
            var tmp = upsellItem.querySelector('.upsellitem__done');
            tmp.classList.add('upsellitem__done--complete');
            tmp.innerHTML = 'Added to Basket';
        }
    };
    xhr.send(formData);
    
}

function closeUpsell(evt){
    console.log(evt.target);
}

//submit plot product add to basket screen
window.addEventListener('load', function(){
    var mainplotform = document.getElementById('mainplotform');
    if(mainplotform){
        var productupsellitems = document.getElementById('productupsellitems');
        if(productupsellitems){
            productupsellitems.addEventListener('click', function(evt){
                if(evt.target.id == 'productupsellitems'){
                    window.location = '/cart';
                }
            });
        }

        mainplotform.addEventListener('submit', function(evt){
            if(productupsellitems && typeof thisisADigitalOnlyPlot == 'undefined'){
                //if there are any upsell items then AJAX submit product to cart and show upsell popup
                evt.preventDefault();
                var xhr = new XMLHttpRequest();
                var formData = new FormData(mainplotform);
                xhr.open('POST', mainplotform.getAttribute('action'));
                xhr.onreadystatechange = function() {//Call a function when the state changes.
                    if(xhr.readyState == 4 && xhr.status == 200) {
                        //redirect to accessories page
                        window.location = Shopify.routes.root + 'collections/accessories/?exp';
                    }
                }
                xhr.send(formData);
            }
        });
    }
});
function continueProduct(){
    if(typeof thisisADigitalOnlyPlot == 'undefined'){
        document.getElementById('addtocartformbutton').click();
    }else{
        document.body.classList.add('showupsell');
    }
}

function checkDigitalOnly() {
    if(document.getElementById('understandthisisdigitalonly').checked){
        document.getElementById('addtocartformbutton').click();
    }else{
        alert('Please check the box to confirm you understand this is a digital download and no physical giftpack will be shipped.');
    }
}

//sort related products on regular product page
window.addEventListener('DOMContentLoaded', function(){
    if(typeof relatedProducts !== 'undefined'){
        var relatedproducts__inner = document.querySelector('.relatedproducts__inner');
        var ids = [];
        if(window.location.search.match(/\?ids\=/)){
            var tmpIds = window.location.search.replace("?ids=","");
            if(tmpIds.match(",")){
                ids = tmpIds.split(",");
            }else{
                ids.push(tmpIds);
            }
        }

        if(ids.length>0){
            //random related products from upsell only
            var tmpIndx = 3;
            relatedProducts.forEach(function(elm){
                if(tmpIndx > 0){
                    if(ids.includes(elm.ID)){
                        tmpIndx--;
                        relatedproducts__inner.innerHTML += `<div class="relatedproduct">
                                ` + (elm.IMAGE != '' ? '<img src="' + elm.IMAGE + '" alt="" loading="lazy">' : '<div class="relatedproduct__noimage"><!-- empty --></div>') + `
                                <div class="relatedproduct__title">` + elm.TITLE + `</div>
                                <a class="button button--gold" href="` + elm.URL + `?ids=` + ids.join(",") + `">View Product</a>
                            </div>`;
                    }
                }
            });
        }else{
            //random related products
            relatedProducts.forEach(function(elm, indx){
                if(indx<3){
                    relatedproducts__inner.innerHTML += `<div class="relatedproduct">
                            <a href="` + elm.URL + `">` + (elm.IMAGE != '' ? '<img src="' + elm.IMAGE + '" alt="" loading="lazy">' : '<div class="relatedproduct__noimage"><!-- empty --></div>') + `</a>
                            <a href="` + elm.URL + `"><div class="relatedproduct__title">` + elm.TITLE + `</div></a>
                            <a class="button button--gold" href="` + elm.URL + `">View Product</a>
                        </div>`;
                }
            });
        }
    }
});

//update table cells
window.addEventListener('load', function(){
    document.querySelectorAll('table').forEach(function(elm){
        var headings = elm.querySelectorAll('table th');
        if(headings.length>0){
            elm.querySelectorAll('table tr:not(.total)').forEach(function(elmTR){
                elmTR.querySelectorAll('td').forEach(function(elmTD, indx){
                    var tmpTH = document.createElement('span');
                    tmpTH.innerHTML = headings[indx].innerHTML;
                    elmTD.prepend(tmpTH);
                });
            });
        }
    });
});

//submit accessories add to basket feature
function addToBasket(val){
    var frm = document.getElementById('product_form_' + val);
    var bsktlink = frm.querySelector('.addtobasketlink');

    var xhr = new XMLHttpRequest();
    var formData = new FormData(frm);
    xhr.open('POST', frm.getAttribute('action'));

    bsktlink.innerHTML = 'Adding...';
    bsktlink.href = '#';

    xhr.responseType = 'document';
    xhr.onload = function() {
        if (xhr.status === 200) {
            bsktlink.innerHTML = 'Added - view cart';
            bsktlink.href = '/cart';
        }
    };
    xhr.send(formData);
}